import React from "react";
import translation from "../../Translation/Ladning.json"; 

const Kpi = () => {
  const officers = [
    { name: "Haized", Aktif: 76, TidakAktif: 25 },
    { name: "Aina", Aktif: 70, TidakAktif: 50 },
    { name: "Farid", Aktif: 20, TidakAktif: 27 },
    { name: "Nadia", Aktif: 80, TidakAktif: 52 },
  ];

  const t = translation.Kpi; 

  return (
    <div className="p-5 rounded-md shadow-md border bg-white max-h-[50vh] overflow-auto">
      <h4 className="mb-3 text-lg font-semibold uppercase text-gray-700">
        {t.title}
      </h4>

      <table className="w-full border-collapse">
        <thead>
          <tr className="text-gray-700">
            <th className="py-2 px-3 text-left">{t.name}</th>
            <th className="py-2 px-3 text-left">{t.active_kpi}</th>
            <th className="py-2 px-3 text-left">{t.inactive_kpi}</th>
          </tr>
        </thead>

        <tbody>
          {officers.map((officer, index) => (
            <tr
              key={index}
              className="border-b hover:bg-gray-50 transition duration-200"
            >
              <td className="py-2 px-3">{officer.name}</td>
              <td className="py-2 px-3">{officer.Aktif} %</td>
              <td className="py-2 px-3">{officer.TidakAktif} %</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Kpi;
